import { getProductionConfig } from './production';
import { getTestingEnvConfig } from './testingEnv';
import { getDevelopmentConfig } from './development';
export function isProduction() {
    window.location.host === 'www.tapresearch.com';
}
export function getEnvironment() {
    var host = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.host;
    if (host.match(/^.*\.tapresearch\.com$/)) {
        return host.includes('www') ? 'production' : 'testingEnv';
    } else {
        return 'development';
    }
}
var FiveMinutes = 1 * 1000 * 60 * 5;
export var baseConfig = {
    mockRequests: false,
    requests: {
        healthStatus: {
            pollingInterval: 30000
        },
        campaignAlerts: {
            pollingInterval: FiveMinutes
        },
        matchesStats: {
            pollingInterval: FiveMinutes
        },
        completesStats: {
            pollingInterval: FiveMinutes
        },
        quotaStats: {
            pollingInterval: FiveMinutes
        },
        campaignFieldingStats: {
            pollingInterval: FiveMinutes
        }
    }
};
export var getTapiConfig = function() {
    switch(getEnvironment()){
        case 'production':
            return getProductionConfig(baseConfig);
        case 'testingEnv':
            return getTestingEnvConfig(baseConfig);
        case 'development':
            return getDevelopmentConfig(baseConfig);
        default:
            return baseConfig;
    }
};
export var config = getTapiConfig();
export var setTapiConfig = function() {
    var tapiConfig = getTapiConfig();
    window.tapiConfig = tapiConfig;
};
